// TanStack Query hooks for the Cohort entity (reads).
// Thin TanStack wrapper around CohortService.getManaged.

import { useQuery } from '@tanstack/react-query';
import CohortService from '@/services/CohortService';
import { COHORT_KEYS } from './keys';

/**
 * Cohorts the current user manages (any role, not just admin).
 *
 * `staleTime: Infinity` — cohort enrollment is session-static, same lifecycle
 * as the enrolled-programs query above.
 *
 * `retry: false` — fail fast on auth/network errors so the consumer's
 * error branch fires immediately rather than after silent retries.
 */
export function useUserCohorts() {
  return useQuery({
    queryKey: COHORT_KEYS.managed(),
    queryFn: CohortService.getManaged,
    staleTime: Infinity,
    retry: false,
  });
}
